/**Dependencies */
import React from "react";

/**Components */

/**Images */

export const PoliticaPrivacidad = () => {
  return (
    <div className="py-5">
      <div className="container text-terminos py-5 border-top border-black">
        <div className="w-100 d-grid justify-content-start">
          <h1
            className="text-lg-start text-start title-home destinos-inigualables"
            style={{ fontWeight: 700, letterSpacing: "3px" }}
          >
            POLÍTICAS DE PRIVACIDAD
          </h1>
        </div>
        <p style={{ textAlign: "justify" }}>
          En cumplimiento con lo establecido por la Ley Federal de Protección de
          Datos Personales en Posesión de Particulares (LFPDPPP), TUCANCUN
          MARZAH SAS DE CV, pone a su disposición el siguiente Aviso de
          Privacidad: <br />
          <br />
          Responsable de la protección y tratamiento de sus Datos Personales
          TUCANCUN MARZAH SAS DE CV (En lo sucesivo "AGENCIA MARZAH"), con
          domicilio en Paseo Tulum MZ 17 LT 1 CASA 2A SM 514. Benito Juárez,
          Quintana Roo. México. CP 77535.
          <br />
          <br />
          Medios de obtención de Datos Personales
          <br />
          <br />
          Los datos personales que AGENCIA MARZAH recabe de usted, serán
          destinados únicamente para los fines descritos en el presente aviso de
          privacidad y podrán ser recabados de las siguientes formas:
          <br />
          <br />
          <ul>
            <li>
              De manera directa, ingresando sus datos o utilizando los servicios
              en línea a través de la página AGENCIA MARZAH.{" "}
            </li>
            <li>
              De manera directa, a través de nuestro centro de reservación
              telefónica (Call Center).
            </li>
            <li>
              De manera directa, a través de nuestras cuentas oficiales de redes
              sociales.
            </li>
          </ul>
          De manera personal, a través de nuestros representantes de
          reservaciones. Datos recabados, los datos que AGENCIA MARZAH recabe de
          usted, serán los siguientes:
          <ul>
            <li>Nombre completo.</li>
            <li>Número de teléfono.</li>
            <li>Correo electrónico.</li>
          </ul>
          Domicilio y datos financieros como lo son:
          <ul>
            <li>Número de tarjeta de crédito.</li>
            <li>Nombre del titular de la misma.</li>
            <li>Fecha de vencimiento.</li>
          </ul>
          Código de seguridad y aquellos datos que resulten necesarios para
          completar y administrar las reservaciones solicitadas por usted.
          <br />
          <br />
          Finalidad de los Datos Personales recabados
          <br />
          <br />
          Sus datos personales serán recabados para las siguientes finalidades
          principales que son necesarias para el servicio que solicita:
          Procesamiento, seguimiento, actualización, modificación, cancelación y
          confirmación de los servicios por usted reservados con AGENCIA MARZAH
          a través de sus medios, con fines financieros y crediticios, para dar
          cumplimiento a las obligaciones contraídas con usted y con nuestros
          proveedores. En el caso de reservaciones que incluyan transportación
          aérea, para que la aerolínea pueda contactar proactivamente con el
          pasajero en caso de interrupción en las operaciones o bien para
          proporcionar al cliente información actualizada acerca de su viaje. Lo
          anterior implica ciertas ventajas para usted como, por ejemplo:
          <br />
          <br />
          <ul>
            <li>Actualizaciones sobre vuelos en tiempo real.</li>
            <li>
              Notificaciones proactivas en caso de interrupción del servicio
              (cancelaciones, retrasos, etc.).
            </li>
            <li>Actualizaciones relacionadas con el equipaje.</li>
            <li>
              Envío de la información del cambio de reserva o tarjeta de
              embarque de forma automática, para los siguientes vuelos
              disponibles.
            </li>
            <li>
              Reducción de tiempo de espera, ansiedad y molestias, durante las
              interrupciones en el servicio.
            </li>
            <li>Una mejor experiencia del cliente.</li>
          </ul>
          Asimismo, los datos que le sean recabados se utilizarán para ponerse
          en contacto con usted para ofrecerles mayor información para la
          generación de posibles reservas. Y de manera accesoria, utilizaremos
          su información personal para las siguientes finalidades que no son
          necesarias para el servicio solicitado, pero que nos permiten y
          facilitan una mejor atención:
          <br />
          <br />
          Evaluar la calidad del servicio, realizar sondeos sobre hábitos y
          preferencias de viaje, para participar en concursos y sorteos,
          programas de lealtad, implementación y desarrollo de campañas
          publicitarias, así como para el envío de promociones, ofertas,
          servicios y fines publicitarios.
          <br />
          <br />
          Los titulares de manera inmediata y gratuita podrán en cualquier
          momento solicitar la cancelación de envío de correos electrónicos con
          fines publicitarios por parte de AGENCIA MARZAH, haciendo clic en el
          link "Cancelar suscripción.” En caso de que no desee que sus datos
          personales sean tratados para estos fines adicionales, usted puede
          presentar desde este momento un escrito vía correo electrónico a la
          dirección info@agenciamarzah.com <br />
          <br />
          Transferencia de datos, nacional e internacional En virtud de lo
          expuesto en los artículos 36 y 37 de la LFPDPPP sus datos personales
          podrán ser transferidos y/o compartidos a: Cuando la transferencia sea
          necesaria por virtud de un contrato celebrado o por celebrar en
          interés del titular, por el responsable y un tercero. Cuando la
          transferencia sea precisa para el mantenimiento o cumplimiento de una
          relación jurídica entre el responsable y el titular tales como los
          Proveedores, Proveedores de Servicios Turísticos, Instituciones
          Bancarias y Crediticias, y entre otras.
          <br />
          <br />
          Es importante señalar que los terceros a los que se transfieran sus
          datos personales se obligarán en los mismos términos del presente
          Aviso de Privacidad y cumplirán con las medidas de seguridad y
          confidencialidad correspondientes.
          <br />
          <br />
          De cualquier manera, nos comprometemos a no transferir su información
          personal a terceros sin su consentimiento, salvo en el caso de lo
          previsto en el artículo 37 de la Ley Federal de Protección de Datos
          Personales en Posesión de los Particulares, así como a realizar esta
          transferencia en los términos que fija dicha Ley.
          <br />
          <br />
          Ejercicio de los Derechos ARCO
          <br />
          <br />
          El artículo 28 de la LFPDPPP, le otorga cuatro derechos a ejercer:
          <br />
          El titular tiene derecho a Acceder a sus datos personales que obren en
          poder del responsable, y a conocer el Aviso de Privacidad y sus
          finalidades.
          <br />
          El titular tiene derecho a rectificar sus datos en caso de ser
          inexactos, incorrectos o estén desactualizados.
          <br />
          El titular tiene derecho a cancelar sus datos personales cuando
          considere que no están siendo utilizados para el cumplimiento de los
          fines establecidos en el presente Aviso de Privacidad.
          <br />
          El titular tiene derecho a oponerse al tratamiento de sus datos
          personales respecto a alguno de los fines establecidos en el presente
          Aviso de Privacidad.
          <br />
          Derecho de revocar su consentimiento para el tratamiento de datos el
          Artículo 8 de La LFPDPPP, prevé la posibilidad de revocar el
          consentimiento otorgado para el tratamiento de sus datos personales.{" "}
          <br />
          Para revocarlo usted podrá solicitar, el mismo mecanismo y
          procedimiento para el ejercicio de los Derechos ARCO previsto en el
          presente aviso. No obstante AGENCIA MARZAH, le informa que el mantener
          sus datos personales en su base de datos, le permitirá entender mejor
          sus necesidades con base a su historial y con ello ofrecerle un mejor
          servicio en sus futuras reservaciones.
          <br />
          <br />
          Mecanismos para el ejercicio de los Derechos ARCO y Revocación del
          consentimiento para el tratamiento de sus datos Para ejercer sus
          derechos de Acceso, Rectificación, Cancelación y Oposición o su
          derecho a revocar el consentimiento para el tratamiento de sus datos
          personales, deberá llenar y enviar dicha notificación, el cual deberá
          remitir a AGENCIA MARZAH a través del correo electrónico
          info@agenciamarzah.com, o dirigir el formato físicamente a la
          siguiente dirección: Paseo Tulum MZ 17 LT 1 CASA 2A SM 514. Benito
          Juárez, Quintana Roo. México. CP 77535, con atención al Departamento
          de Protección de Datos Personales, o bien, podrá presentar su
          solicitud por escrito y en idioma español y cumpliendo con los
          requisitos señalados en el artículo 29 del reglamento de la LFPDPPP.
          Para la procedencia del ejercicio de sus Derechos ARCO usted deberá
          acreditar la titularidad de sus derechos ARCO o bien la representación
          respecto al titular a través de la presentación de copia de su
          documento de identificación y la exhibición del original para su
          cotejo, o aquellos instrumentos establecidos en el artículo 89 del
          reglamento de la LFPDPPP.
          <br />
          <br />
          Artículo 29.- La solicitud de acceso, rectificación, cancelación u
          oposición deberá contener y acompañar lo siguiente:
          <br />
          <br />
          <ul>
            <li>
              El nombre del titular y domicilio u otro medio para comunicarle la
              respuesta a su solicitud.
            </li>
            <li>
              Los documentos que acrediten la identidad o, en su caso, la
              representación legal del titular.
            </li>
            <li>
              La descripción clara y precisa de los datos personales respecto de
              los que se busca ejercer alguno de los derechos antes mencionados,
              y cualquier otro elemento o documento que facilite la localización
              de los datos personales.
            </li>
          </ul>
          AGENCIA MARZAH le dará seguimiento a su solicitud en un lapso de 20
          días hábiles contados a partir de la recepción de dicho FORMATO o
          solicitud, con la documentación completa, para comunicarle sobre la
          procedencia de la misma. En caso de resultar procedente, AGENCIA
          MARZAH contará con un plazo máximo de 15 días hábiles para hacer
          efectivo su derecho ARCO.
          <br />
          <br />
          Medidas para proteger su información y para limitar el uso o
          divulgación de su información personal
          <br />
          <br />
          Será resguardada bajo estricta confidencialidad y para prevenir
          razonablemente el uso o divulgación indebida de la misma, hemos
          implementado medidas de seguridad física, técnicas y administrativas
          de conformidad con la Ley Federal de Protección de Datos Personales en
          Posesión de los Particulares y demás normatividad aplicable.
          <br />
          <br />
          En particular, contamos con una política de privacidad, cursos de
          capacitación al personal, acceso restringido a información personal
          sólo a usuarios autorizados, oficiales de privacidad, un inventario de
          datos personales (debidamente clasificados por categoría de datos), de
          los sistemas de tratamiento, análisis de riesgos y cláusulas
          contractuales.
          <br />
          <br />
          Con objeto de que usted pueda limitar el uso y divulgación de su
          información personal, le ofrecemos la opción de su inscripción en el
          Registro Público para evitar Publicidad (REPEP), que está a cargo de
          la Procuraduría Federal del Consumidor (PROFECO), con la finalidad de
          que sus datos personales no sean utilizados para recibir publicidad o
          promociones de empresas de bienes o servicios. Para mayor información
          sobre este registro, usted puede consultar el portal de Internet de la
          PROFECO, o bien ponerse en contacto directo con ésta.
          <br />
          <br />
          Siempre que el titular considere que ha sido vulnerado su derecho a la
          protección de datos, cuenta con el derecho de acudir al INAI como
          institución de apoyo para el cumplimiento de la normativa ARCO.
          <br />
          <br />
          SSL y Cookies
          <br />
          <br />
          En <a href="https://marzahtravel.com">
            https://marzahtravel.com
          </a>{" "}
          utilizamos el candado de seguridad SSL (Secure Socket Layer). Este es
          un protocolo de seguridad para lograr que la transmisión de datos
          entre un servidor y un usuario (o viceversa) a través de Internet, sea
          completamente segura. El certificado SSL permite proteger sus datos en
          un entorno seguro ya que la información es encriptada y enviada
          directamente al servidor.
          <br />
          <br />
          <a href="https://marzahtravel.com">https://marzahtravel.com</a>{" "}
          utiliza cookies propias y de terceros para analizar su navegación y
          ofrecerle un servicio más personalizado acorde a sus intereses.
          <br />
          <br />
          Modificaciones al presente aviso de privacidad
          <br />
          <br />
          AGENCIA MARZAH podrá efectuar en cualquier momento modificaciones o
          actualizaciones al presente Aviso de Privacidad. Las modificaciones o
          actualizaciones que se efectúen, entrarán en vigor en el momento en
          que son publicados en el sitio de internet{" "}
          <a href="https://marzahtravel.com/politica-de-privacidad">
            https://marzahtravel.com/politica-de-privacidad
          </a>
          , en sus sitios afiliados o en cualquier medio de comunicación que
          utilice para publicarlo, por lo que se recomienda su revisión
          continua. <br />
          <br />
          Aceptación expresa del Aviso de Privacidad Si usted no se opone de
          manera expresa al presente aviso y sus actualizaciones se dan por
          entendido que ha otorgado su consentimiento tácito en términos del
          artículo 8 de la LFPDPPP.{" "}
          <a href="https://marzahtravel.com">https://marzahtravel.com</a> le
          sugiere la lectura del presente Aviso de Privacidad, ya que al aportar
          sus datos por cualquier medio, constituye la aceptación del presente
          Aviso de Privacidad.
          <br />
          <br />
          <strong>Actualizado a Enero de 2025.</strong>
        </p>
        <br />
      </div>
    </div>
  );
};
